import React from 'react'
import { useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom'

function Play() {
    const navigate = useNavigate();
    const { id, title, uid, play_id } = useParams();

    useEffect(() => {
        if(title !== undefined && play_id !== undefined) {
            navigate(`/video/:${id}/:${title}/playlist/:${play_id}`);
        }else if(title === undefined && play_id !== undefined) {
            navigate(`/video/:${id}/playlist/:${play_id}`);
        }else if(title !== undefined && uid !== undefined) {
            navigate(`/video/:${id}/:${title}/list/:${uid}`);
        }else if(title === undefined && uid !== undefined) {
            navigate(`/video/:${id}/list/:${uid}`);
        }else {
            navigate(`/video/${id}/${title}`);
        }
    }, [id]);

    return (
        <></>
    )
}

export default Play